'use client';

import { RadioGroup } from '@base-ui/react/radio-group';
import cn from 'classnames';
import type { ChangeEvent, ComponentProps, ReactNode } from 'react';

export type SwdRadioGroupProps = Omit<ComponentProps<typeof RadioGroup>, 'onChange' | 'onValueChange'> & {
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onValueChange?: ComponentProps<typeof RadioGroup>['onValueChange'];
  children?: ReactNode;
};

/**
 * MUI-compatible RadioGroup: maps `onChange` + synthetic `target.name` / `target.value` to Base UI `onValueChange`.
 */
export function SwdRadioGroup({ className, name, onChange, onValueChange, value, ...props }: SwdRadioGroupProps) {
  const controlledValue = value ?? '';

  return (
    <RadioGroup
      className={cn(className)}
      name={name}
      value={controlledValue}
      {...props}
      onValueChange={(v, details) => {
        onValueChange?.(v, details);
        onChange?.({
          target: { name: name ?? '', value: v ?? '' },
        } as ChangeEvent<HTMLInputElement>);
      }}
    />
  );
}
